import { TextField as TextFieldPrimitive } from '@radix-ui/themes'
import { withProps } from '../component-utils'
import styles from './text-field.module.css'

export { Root, Slot }

const Root = withProps(TextFieldPrimitive.Root, (props) => ({
  className: styles.root,
  'data-1p-ignore': props.autoComplete === 'off' || undefined,
}))

const Slot = withProps(TextFieldPrimitive.Slot, {
  className: styles.slot,
})
